import React from "react"
import { Link, useHistory } from "react-router-dom"
import { Helmet } from "react-helmet"

import { Popover } from "@headlessui/react"

import { useAuth } from "hooks/useAuth"

const Layout = ({ title, navigation, isLoading, children }) => {
  return (
    <>
      <Helmet>
        <title>{title || "GTR"}</title>
      </Helmet>

      <div className="w-full min-h-screen bg-gray-100 text-gray-900">
        {navigation && <TopNavigation />}

        {isLoading ? (
          <div className="fixed inset-0 min-h-screen flex justify-center items-center bg-gray-800">
            <div className="loader ">Loading...</div>
          </div>
        ) : (
          children
        )}
      </div>
    </>
  )
}

Layout.defaultProps = {
  navigation: true,
}

export default Layout

const TopNavigation = () => {
  const history = useHistory()
  const activePath = history.location.pathname

  const { role, user } = useAuth()

  const TOP_ROUTES = [
    // { name: "Dashboard", path: "/" },
    { name: "Groups", path: "/groups" },
    { name: "Individual", path: "/individual" },
    // { name: "Payments", path: "/payments" },
  ]

  const SIDE_ROUTES = [
    { name: "Account", path: "/account" },

    ...(["ADMIN", "AGENT"].includes(role)
      ? [
          { name: "Agencies", path: "/agencies" },
          { name: "Media", path: "/media" },
          { name: "Passengers", path: "/passengers" },
          { name: "Users", path: "/users" },
        ]
      : []),
  ]

  return (
    <nav className="bg-gray-800">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0 flex justify-center items-center">
              <img className="w-8 text-gray-100" src="/logo.svg" alt="logo" />
            </div>

            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline">
                {TOP_ROUTES.map((route, index) => (
                  <Link
                    key={index}
                    to={route.path}
                    className={`px-4 py-2 rounded-md text-sm font-medium text-white ${
                      activePath === route.path &&
                      "outline-none text-white bg-gray-700"
                    } `}
                  >
                    {route.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <div className="hidden md:block">
            <div className="ml-4 flex items-center md:ml-6">
              <Popover className="relative">
                <Popover.Button>
                  <button
                    className="max-w-xs flex items-center text-sm rounded-full text-white focus:outline-none focus:shadow-solid"
                    id="user-menu"
                    aria-label="User menu"
                    aria-haspopup="true"
                  >
                    <img
                      className="h-8 w-8 object-cover rounded-full"
                      src={user?.photoURL}
                      alt=""
                    />
                  </button>
                </Popover.Button>

                <Popover.Panel className="absolute z-50 right-0 px-4 mt-3  sm:px-0 lg:max-w-xs w-48">
                  <div className="overflow-hidden shadow-lg ring-1 ring-black ring-opacity-5">
                    <div className="relative flex flex-col  bg-white">
                      <div className="px-3 py-2 text-xs font-medium text-gray-900 border-b-2 border-gray-100">
                        <p>Signed in as</p>
                        <p>{user.displayName}</p>
                      </div>
                      {SIDE_ROUTES.map((route, index) => (
                        <Link
                          key={index}
                          to={route.path}
                          className="px-3 py-2 text-xs font-medium text-gray-900 hover:bg-blue-500 hover:text-gray-100"
                        >
                          {route.name}
                        </Link>
                      ))}

                      <Link
                        to="/logout"
                        className="border-t-2 border-gray-100 px-3 py-2 text-xs font-medium text-gray-900 hover:bg-blue-500 hover:text-gray-100"
                      >
                        Logout
                      </Link>
                    </div>

                    <img src="/solutions.jpg" alt="" />
                  </div>
                </Popover.Panel>
              </Popover>
              {/* <button
                className="p-1 border-2 border-transparent text-gray-400 rounded-full hover:text-white focus:outline-none focus:text-white focus:bg-gray-700"
                aria-label="Notifications"
              >
                <svg
                  className="h-6 w-6"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke-width="2"
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
              </button> */}

              {/* <div className="ml-3 relative">
                <div>
                 
                </div> */}

              {/* <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg">
              <div
                className="py-1 rounded-md bg-white shadow-xs"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu"
              >
                <a
                  href="#"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  role="menuitem"
                >
                  Your Profile
                </a>
                <a
                  href="#"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  role="menuitem"
                >
                  Settings
                </a>
                <a
                  href="#"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  role="menuitem"
                >
                  Sign out
                </a>
              </div>
            </div> */}
              {/* </div> */}
            </div>
          </div>
          {/* <div className="-mr-2 flex md:hidden">
            <button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white">
              <svg
                className="block h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <svg
                className="hidden h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div> */}
        </div>
      </div>

      {/* <div className="hidden md:hidden">
        <div className="px-2 pt-2 pb-3 sm:px-3">
          <a
            href="#"
            className="block px-3 py-2 rounded-md text-base font-medium text-white bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700"
          >
            Trips
          </a>
          <a
            href="#"
            className="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
          >
            Bookings
          </a>

          <a
            href="#"
            className="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
          >
            Reports
          </a>
        </div>
        <div className="pt-4 pb-3 border-t border-gray-700">
          <div className="flex items-center px-5">
            <div className="flex-shrink-0">
              <img
                className="h-10 w-10 rounded-full"
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                alt=""
              />
            </div>
            <div className="ml-3">
              <div className="text-base font-medium leading-none text-white">
                Tom Cook
              </div>
              <div className="mt-1 text-sm font-medium leading-none text-gray-400">
                tom@example.com
              </div>
            </div>
          </div>
          <div className="mt-3 px-2">
            <a
              href="#"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
            >
              Your Profile
            </a>
            <a
              href="#"
              className="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
            >
              Settings
            </a>
            <a
              href="#"
              className="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
            >
              Sign out
            </a>
          </div>
        </div>
      </div> */}
    </nav>
  )
}
